var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import FrontPage from '@/template/views/FrontPage.vue';
import RecordHistoryView from '@/template/views/RecordHistoryView.vue';
import NewApplicationView from '@/template/views/NewApplicationView.vue';
import PaymentsView from '@/template/views/PaymentsView.vue';
import ResetView from '@/template/views/ResetView.vue';
import ChangeRequestsView from '@/template/views/ChangeRequestsView.vue';
import CorrespondencesView from '@/template/views/CorrespondencesView.vue';
import CorrespondenceView from '@/template/components/correspondence/CorrespondenceView.vue';
import AccountNumberRequestView from '@/template/views/AccountNumberRequestView.vue';
import PaymentBanView from '@/template/views/PaymentBanView.vue';
import LegacyInformationRequestView from '@/template/views/LegacyInformationRequestView.vue';
import InstructionsView from '@/template/views/InstructionsView.vue';
import OrganisationInformationView from '@/template/views/OrganisationInformationView.vue';
import UserManagementView from '@/template/views/UserManagementView.vue';
import SessionExpiredView from '@/template/views/SessionExpiredView.vue';
import AccessibilityStatement from '@/template/components/AccessibilityStatement.vue';
import PrivacyPolicy from '@/template/components/PrivacyPolicy.vue';
import { route as aidApplicationRoute } from './aidApplicationRoutes';
import { route as organisationYearlyReportRoute } from './organisationYearlyReportRoutes';
import { route as expandedSBERoutes } from './expandedSBERoutes';
import { route as summaryReportRoutes } from './summaryReportRoutes';
import { route as continuousReportSummaryRoutes } from './continuousReportSummaryRoutes';
import { route as continuousReportRoutes } from './continuousReportRoutes';
import { route as paymentPlanRoute } from './paymentPlanRoute';
import { route as paymentRequestERRoute } from './paymentRequestERRoute';
import { route as aidTargetYearlyReportRoutes } from './aidTargetYearlyReportRoute';
import { route as investmentReportRoutes } from './investmentReportRoutes';
import { route as aupReportRoutes } from './aupReportRoute';
import { route as materialRequestRoute } from './materialRequestRoute';
import { routes as refundRoutes } from './refundRoutes';
import { routes as changeRequestRoutes } from './changeRequestRoutes';
import { feedbackRoutes } from './feedbackRoutes';
import { notificationRoutes } from './notificationRoutes';
export var routes = getDefaultRoutes();
/**
 *
 * Creates the default set of routes - excluding routes which are dependent on the feature configuration
 *
 **/
export function getDefaultRoutes() {
    return getRoutes(null);
}
/**
 *
 * Creates routes based on the given feature configuration
 *
 **/
export function getRoutes(configuration) {
    var routes = [{
            path: '*',
            redirect: { name: 'frontPage' }
        }];
    routes.push.apply(routes, __spread(getStaticMenuRoutes()));
    if (configuration) {
        routes.push.apply(routes, __spread(getFeatureRoutes(configuration.featureConfiguration)));
        if (configuration.featureConfiguration.enableResetor) {
            routes.push(getResetRoute());
        }
    }
    routes.push(aidApplicationRoute);
    routes.push(organisationYearlyReportRoute);
    routes.push(expandedSBERoutes);
    routes.push(summaryReportRoutes);
    routes.push(continuousReportRoutes);
    routes.push(continuousReportSummaryRoutes);
    routes.push(paymentPlanRoute);
    routes.push(paymentRequestERRoute);
    routes.push(aidTargetYearlyReportRoutes);
    routes.push(investmentReportRoutes);
    routes.push(aupReportRoutes);
    routes.push(materialRequestRoute);
    routes.push.apply(routes, __spread(refundRoutes));
    routes.push.apply(routes, __spread(changeRequestRoutes));
    routes.push.apply(routes, __spread(feedbackRoutes));
    routes.push.apply(routes, __spread(notificationRoutes));
    routes.push(getSessionExpiredRoute());
    return routes;
}
function getResetRoute() {
    return {
        name: 'reset',
        path: '/reset',
        component: ResetView
    };
}
function getSessionExpiredRoute() {
    return {
        name: 'sessionExpired',
        path: '/sessionExpired',
        component: SessionExpiredView,
        meta: {
            hideNav: true
        }
    };
}
function getStaticMenuRoutes() {
    return [{
            name: 'frontPage',
            path: '/',
            component: FrontPage,
            meta: {
                title: 'Menu.FrontPage',
                mainNav: true
            }
        },
        {
            name: 'recordHistory',
            path: '/recordHistory',
            component: RecordHistoryView,
            meta: {
                title: 'Menu.RecordHistory',
                mainNav: true
            }
        },
        {
            name: 'instructions',
            path: '/instructions/:id/:type?/:metaType?',
            component: InstructionsView,
            meta: {
                title: 'InstructionsTitle',
                hideNav: true
            }
        },
        {
            name: 'organisation-information',
            path: '/organisationInformation/:aidType?/:aidTargetId?',
            component: OrganisationInformationView,
            meta: {
                title: 'Organisation.Title'
            }
        },
        {
            name: 'user-management',
            path: '/userManagement',
            component: UserManagementView,
            meta: {
                title: 'UserManagement.Title',
                procurationOnly: true
            }
        },
        {
            name: 'correspondence',
            path: '/correspondence/:id',
            component: CorrespondenceView,
            meta: {
                title: 'Correspondence.Title'
            }
        },
        {
            name: 'accountNumberRequest',
            path: '/accountNumberRequest/:id',
            component: AccountNumberRequestView,
            meta: {
                title: 'AccountNumberRequest.Title',
                section: 1
            }
        },
        {
            name: 'paymentBan',
            path: '/paymentBan/:id',
            component: PaymentBanView,
            meta: {
                title: 'Forms.PaymentBan',
                section: 1
            }
        },
        {
            name: 'legacyInformationRequest',
            path: '/informationRequest/:id',
            component: LegacyInformationRequestView,
            meta: {
                title: 'Forms.LegacyInformationRequest',
                section: 1
            }
        },
        {
            name: 'accessibility-statement',
            path: '/accessibilityStatement',
            component: AccessibilityStatement,
            meta: {
                title: 'AccessibilityStatement',
                hideNav: true
            }
        },
        {
            name: 'privacy-policy',
            path: '/privacyPolicy',
            component: PrivacyPolicy,
            meta: {
                title: 'PrivacyPolicy',
                hideNav: true
            }
        }];
}
/**
 *
 * Creates main menu feature routes based on the given feature configuration
 *
 **/
export function getFeatureRoutes(features) {
    var featureRoutes = [];
    if (features.showAidApplications) {
        featureRoutes.push({
            name: 'aidApplications',
            path: '/aidApplications',
            component: NewApplicationView,
            meta: {
                title: 'Menu.AidApplications',
                mainNav: true
            }
        });
    }
    if (features.showPayments) {
        featureRoutes.push({
            name: 'payments',
            path: '/payments',
            component: PaymentsView,
            meta: {
                title: 'Menu.Payments',
                mainNav: true
            }
        });
    }
    if (features.showChangeRequests) {
        featureRoutes.push({
            name: 'changeRequests',
            path: '/changeRequests',
            component: ChangeRequestsView,
            meta: {
                title: 'Menu.ChangeRequests',
                mainNav: true
            }
        });
    }
    if (features.showCorrespondences) {
        featureRoutes.push({
            name: 'correspondences',
            path: '/correspondences',
            component: CorrespondencesView,
            meta: {
                title: 'Menu.Correspondences',
                mainNav: true,
                showCorrespondencesBadge: true
            }
        });
    }
    return featureRoutes;
}
